/**
 * Shared defaults for UI / Electron storage repair entry points.
 * Keeps Settings, Bootstrap diagnostic, and Electron menu in sync.
 */

/** Safe interactive repair — no reinstall recovery, syncs UI after. */
export const DEFAULT_UI_REPAIR_OPTIONS = Object.freeze({
  deep: false,
  /** Off by default — keep login business id sticky (opt-in only). */
  relinkUser: false,
  syncUi: true,
  skipReinstallRecovery: true,
  /** Always re-run facture numbering (Achat) — idle migration can skip on empty cache. */
  forceInvoiceNumbers: true,
  refreshDomainCaches: true,
  /** Achat/Vente IDs, doublons, orphelins + inventaire/stock */
  repairAchatVenteIds: true,
  repairInventoryStock: true,
  /**
   * Rebuild lots from completed achat lines (purchase-line qty as remaining).
   * OFF by default — re-inflates on-hand after sales (ADR-0016). Prefer
   * Settings → ledger reproject / empty-lot migration only. Opt-in when lots
   * are missing shells and inventory was never sold (rare recovery).
   * Draft (ajouter achat) is never a stock source.
   */
  forceLotRebuildFromAchats: false,
  /**
   * Prevent Electron OOM (exit 536870904 / -536870904): chunked writes, capped stock warm,
   * skip heavy sales renumber when datasets are large.
   */
  lightMemoryRepair: true,
  /** Cap warm path; full rebuild from achats raises this in repair migration. */
  maxStockRecalcEntries: 500,
  skipSalesRepair: true,
  /**
   * Do NOT replay checkout from sale finalize journal during UI repair.
   * Replay can hang on customer PCs; sweep/cleanup is enough and non-blocking.
   */
  saleJournalReplay: false
});

/**
 * After reinstall / empty catalog: restore backups, relink empty login bucket, hydrate.
 * Use from Bootstrap diagnostic / dedicated "Récupération" action — not light Settings repair.
 */
export const REINSTALL_RECOVERY_REPAIR_OPTIONS = Object.freeze({
  ...DEFAULT_UI_REPAIR_OPTIONS,
  relinkUser: true,
  skipReinstallRecovery: false,
  deep: true,
  forceInvoiceNumbers: true,
  refreshDomainCaches: true
});

export function mergeRepairOptions(overrides = {}) {
  return { ...DEFAULT_UI_REPAIR_OPTIONS, ...overrides };
}

export function mergeReinstallRepairOptions(overrides = {}) {
  return { ...REINSTALL_RECOVERY_REPAIR_OPTIONS, ...overrides };
}
